import { identity } from 'fp-ts/function';
export var unify = identity;